// Pilihan tema warna (disimpan per perangkat).
import { store } from '../core/storage.js';
import { $$ } from '../core/dom.js';
import { sfx } from './sound.js';

export const TEMA = [
  { id: 'otomatis', nama: 'Otomatis', warna: ['#E8F3FF', '#141537'] },
  { id: 'langit', nama: 'Langit', warna: ['#E8F3FF', '#2F9BFF'] },
  { id: 'samudra', nama: 'Samudra', warna: ['#0D2A55', '#55B0FF'] },
  { id: 'galaksi', nama: 'Galaksi', warna: ['#24124A', '#A584FF'] },
  { id: 'malam', nama: 'Malam', warna: ['#0D0E13', '#FFD04F'] },
  { id: 'hutan', nama: 'Hutan', warna: ['#0C3325', '#38D9A2'] },
];
const KUNCI = 'tka-tema';
export const temaAktif = () => store.get(KUNCI, 'otomatis');

export function pasangTema(id) {
  const t = TEMA.find(x => x.id === id) ? id : 'otomatis';
  if (t === 'otomatis') document.documentElement.removeAttribute('data-tema');
  else document.documentElement.setAttribute('data-tema', t);
  store.set(KUNCI, t);
  const bg = getComputedStyle(document.body).backgroundColor;
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', bg || '#2F9BFF');
  $$('.tema-b').forEach(b => b.setAttribute('aria-checked', b.dataset.tema === t));
}

export function pemilihTema() {
  const now = temaAktif();
  return `<div class="tema-pick" role="radiogroup" aria-label="Tema warna">${TEMA.map(t => `<button class="tema-b" type="button" role="radio" data-tema="${t.id}" aria-checked="${t.id === now}"><span class="tema-sw" style="background:linear-gradient(135deg,${t.warna[0]} 0 55%,${t.warna[1]} 55% 100%)"></span><span>${t.nama}</span></button>`).join('')}</div>`;
}

export function hubungkanPemilih(root = document) {
  $$('.tema-b', root).forEach(b => b.onclick = () => { pasangTema(b.dataset.tema); sfx.tap(); });
}
